import axios from '@/utils/axios'

/**
 * Auth API Service
 * Customize these endpoints based on your actual API documentation
 */

const authService = {
  /**
   * Login user
   * @param {Object} credentials - { email, password }
   * @returns {Promise}
   */
  async login(credentials) {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.post('/auth/login', credentials)
    return response
  },

  /**
   * Register new user
   * @param {Object} userData - { email, password, name, etc. }
   * @returns {Promise}
   */
  async register(userData) {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.post('/auth/register', userData)
    return response
  },

  /**
   * Logout user
   * @returns {Promise}
   */
  async logout() {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.post('/auth/logout')
    return response
  },

  /**
   * Get current user profile
   * @returns {Promise}
   */
  async getCurrentUser() {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.get('/auth/me')
    return response
  },

  /**
   * Refresh authentication token
   * @returns {Promise}
   */
  async refreshToken() {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.post('/auth/refresh')
    return response
  },

  /**
   * Request password reset
   * @param {string} email
   * @returns {Promise}
   */
  async forgotPassword(email) {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.post('/auth/forgot-password', { email })
    return response
  },

  /**
   * Reset password with token
   * @param {Object} data - { token, password, password_confirmation }
   * @returns {Promise}
   */
  async resetPassword(data) {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.post('/auth/reset-password', data)
    return response
  },

  /**
   * Update user profile
   * @param {Object} userData
   * @returns {Promise}
   */
  async updateProfile(userData) {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.put('/auth/profile', userData)
    return response
  },

  /**
   * Change password
   * @param {Object} data - { current_password, new_password, new_password_confirmation }
   * @returns {Promise}
   */
  async changePassword(data) {
    // CUSTOMIZE: Update endpoint based on your API
    const response = await axios.post('/auth/change-password', data)
    return response
  },
}

export default authService
